import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, extractError } from "../lib/api";
import { toast } from "sonner";
import ThemeToggle from "../components/ThemeToggle";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    if (!token) {
      toast.error("Enlace inválido. Solicite uno nuevo.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Contraseña actualizada");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="absolute top-4 right-4">
        <ThemeToggle testid="reset-theme-toggle" />
      </div>
      <div className="w-full max-w-sm bg-card border border-border rounded-md p-8">
        <div className="label-caps mb-2">Nueva contraseña</div>
        <h1 className="font-display text-2xl font-medium mb-2">Restablecer acceso</h1>
        <p className="text-sm text-muted-foreground mb-6">Elija una contraseña de al menos 6 caracteres.</p>
        {!token ? (
          <p className="text-sm text-destructive mb-4">
            Falta el token del enlace. Use el correo completo o solicite uno nuevo.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input
              type="password"
              required
              minLength={6}
              placeholder="Nueva contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-sm text-sm"
            />
            <input
              type="password"
              required
              minLength={6}
              placeholder="Confirmar contraseña"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-sm text-sm"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-primary-foreground text-sm py-2.5 rounded-sm disabled:opacity-60"
            >
              {loading ? "Guardando…" : "Guardar contraseña"}
            </button>
          </form>
        )}
        <p className="mt-6 text-center text-sm space-y-2">
          <Link to="/olvide-contraseña" className="block text-primary underline">
            Solicitar nuevo enlace
          </Link>
          <Link to="/login" className="block text-muted-foreground underline">
            Iniciar sesión
          </Link>
        </p>
      </div>
    </div>
  );
}
